var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a", { staticClass: "card", attrs: { href: "#" } }, [
    _c("img", {
      staticClass: "card-img",
      attrs: { src: "/images/temp/promo_bg.png", alt: "" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "card-img-overlay" }, [
      _c("div", [
        _c(
          "h3",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.title,
                expression: "title",
              },
            ],
            staticClass: "h5 card-title",
          },
          [_vm._v(_vm._s(_vm.title))]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.price,
                expression: "price",
              },
            ],
            staticClass: "card-text",
          },
          [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.fixedPrice,
                    expression: "!fixedPrice",
                  },
                ],
              },
              [_vm._v("od ")]
            ),
            _c("span", { staticClass: "card-price" }, [
              _vm._v(_vm._s(_vm.price)),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "btn btn-warning link stretched-link" }, [
          _vm._v("Kup bilet"),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }